import { BaseClient } from '../BaseClient';
import { Bool, Empty } from '../compiled-protos/common';
import { DeclineProposalRequest, GetRequest,   NewGetRequest,  NewSendProposalDocumentRequest, NewUpdateRequest,  NewUpdateWithoutTokenRequest, NewUpdateWithTokenRequest, Proposal,   ProposalDeclineContext, ProposalIntakeForm, ProposalIntakeFormList, ProposalIntakeSystem, ProposalIntakeSystemList, ProposalIntakeType, ProposalIntakeTypeList, ProposalPdfRequest,  ProposalReminderEvaluation, SearchProposalIntakeReq, SendProposalDocumentRequest, SendProposalReminderRequest, TokenProposal, TokenProposalData, UpdateRequest, UpdateWithTokenRequest } from '../compiled-protos/proposal';
import { ProposalServiceClient } from '../compiled-protos/proposal.client';
import { URLObject } from '../S3File';

class ProposalClient extends BaseClient {
  self: ProposalServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ProposalServiceClient(this.transport);
  }

  public async Get(req: GetRequest) {
    let res = Proposal.create();
    try {
      res = await this.self.get(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Update(req: UpdateRequest) {
    let res = Proposal.create();
    try {
      res = await this.self.update(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async NewUpdate(req: NewUpdateRequest) {
    let res = Proposal.create();
    try {
      res = await this.self.newUpdate(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async CreateToken(req: TokenProposalData) {
    let res = TokenProposal.create();
    try {
      res = await this.self.createToken(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetWithToken(req: TokenProposal) {
    const res = await this.self.getWithToken(req, this.getMetaData()).response;
    return res;
  }

  public async UpdateWithToken(req: UpdateWithTokenRequest) {
    let res = Proposal.create();
    try {
      res = await this.self.updateWithToken(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async NewUpdateWithToken(req: NewUpdateRequest) {
    let res = Proposal.create();
    try {
      res = await this.self.newUpdateWithToken(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async SendProposalDocument(req: SendProposalDocumentRequest) {
    let res = Bool.create();
    try {
      res = await this.self.sendProposalDocument(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async NewSendProposalDocument(req: NewSendProposalDocumentRequest) {
    let res = Bool.create();
    try {
      res = await this.self.newSendProposalDocument(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async getProposalPreview(req: ProposalPdfRequest) {
    let res = URLObject.create()
    try {
      console.log(req,"what we are sending")
      res = await this.self.createProposalPdf(req, this.getMetaData()).response;
      console.log('res',res)
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async newGet(req: NewGetRequest) {
    let res = Proposal.create()
    try {
      res = await this.self.newGet(req, this.getMetaData()).response;
      console.log('res',res)
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async newUpdateWithoutToken(req: NewUpdateWithoutTokenRequest) {
    let res = Proposal.create()
    try {
      res = await this.self.newUpdateWithoutToken(req, this.getMetaData()).response;
      console.log('res',res)
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
  public async newUpdateWithToken(req: NewUpdateWithTokenRequest) {
    let res = Proposal.create()
    try {
      res = await this.self.newUpdateWithToken(req, this.getMetaData()).response;
      console.log('res',res)
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // ProposalIntakeForm methods
  public async CreateProposalIntakeForm(req: ProposalIntakeForm) {
    let res = ProposalIntakeForm.create();
    try {
      res = await this.self.createProposalIntakeForm(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetProposalIntakeForm(req: ProposalIntakeForm) {
    let res = ProposalIntakeForm.create();
    try {
      res = await this.self.getProposalIntakeForm(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGetProposalIntakeForm(req: ProposalIntakeForm) {
    let res = ProposalIntakeFormList.create();
    try {
      // Uncached: the Repair Queue reads this back right after a close-out or reopen.
      res = await this.self.batchGetProposalIntakeForm(req, this.getMetaDataWithoutCache()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async UpdateProposalIntakeForm(req: ProposalIntakeForm) {
    let res = ProposalIntakeForm.create();
    try {
      res = await this.self.updateProposalIntakeForm(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async SubmitProposalIntakeForm(req: ProposalIntakeForm) {
    let res = ProposalIntakeForm.create();
    try {
      res = await this.self.submitProposalIntakeForm(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // No try/catch so callers can read RpcError.code. Uncached because the backend
  // memoizes identical requests for 5s, writes included.
  public async CloseOutProposalIntakeForm(req: ProposalIntakeForm) {
    const res = await this.self.closeOutProposalIntakeForm(req, this.getMetaDataWithoutCache()).response;
    return res;
  }

  public async ReopenProposalIntakeForm(req: ProposalIntakeForm) {
    const res = await this.self.reopenProposalIntakeForm(req, this.getMetaDataWithoutCache()).response;
    return res;
  }

  public async DeleteProposalIntakeForm(req: ProposalIntakeForm) {
    let res = Empty.create();
    try {
      res = await this.self.deleteProposalIntakeForm(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGetProposalIntakeType(req: ProposalIntakeType) {
    let res = ProposalIntakeTypeList.create();
    try {
      res = await this.self.batchGetProposalIntakeType(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async SearchProposalIntake(req: SearchProposalIntakeReq) {
    let res = ProposalIntakeFormList.create();
    try {
      res = await this.self.searchProposalIntake(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // ProposalIntakeSystem methods
  public async CreateProposalIntakeSystem(req: ProposalIntakeSystem) {
    let res = ProposalIntakeSystem.create();
    try {
      res = await this.self.createProposalIntakeSystem(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetProposalIntakeSystem(req: ProposalIntakeSystem) {
    let res = ProposalIntakeSystem.create();
    try {
      res = await this.self.getProposalIntakeSystem(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGetProposalIntakeSystem(req: ProposalIntakeSystem) {
    let res = ProposalIntakeSystemList.create();
    try {
      res = await this.self.batchGetProposalIntakeSystem(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async UpdateProposalIntakeSystem(req: ProposalIntakeSystem) {
    let res = ProposalIntakeSystem.create();
    try {
      res = await this.self.updateProposalIntakeSystem(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async DeleteProposalIntakeSystem(req: ProposalIntakeSystem) {
    let res = Empty.create();
    try {
      res = await this.self.deleteProposalIntakeSystem(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetProposalDeclineContext(req: TokenProposal) {
    const res = await this.self.getProposalDeclineContext(req, this.getMetaData()).response;
    return res;
  }

  public async DeclineProposalWithToken(req: DeclineProposalRequest) {
    const res = await this.self.declineProposalWithToken(req, this.getMetaData()).response;
    return res;
  }

  public async SendProposalReminder(req: SendProposalReminderRequest) {
    const res = await this.self.sendProposalReminder(req, this.getMetaData()).response;
    return res;
  }

  public async EvaluateProposalReminder(req: SendProposalReminderRequest) {
    const res = await this.self.evaluateProposalReminder(req, this.getMetaData()).response;
    return res;
  }

}

export { 
  Proposal, 
  GetRequest, 
  UpdateRequest, 
  TokenProposalData, 
  ProposalPdfRequest,
  TokenProposal, 
  UpdateWithTokenRequest, 
  NewUpdateWithoutTokenRequest,
  NewUpdateWithTokenRequest,
  NewGetRequest,
  ProposalClient,
  NewUpdateRequest,
  SendProposalDocumentRequest,
  NewSendProposalDocumentRequest,
  ProposalIntakeForm,
  ProposalIntakeFormList,
  SearchProposalIntakeReq,
  ProposalIntakeSystem,
  ProposalIntakeSystemList,
  ProposalIntakeType,
  ProposalIntakeTypeList,
  ProposalDeclineContext,
  DeclineProposalRequest,
  SendProposalReminderRequest,
  ProposalReminderEvaluation,
};
